import React from "react"
import Cabecalho from "../Cabecalho"
import { ModeloIzzaGPTComponent } from "./components/ModeloIzzaGPTComponent"

export function ModeloIzzaGPTPage() {
    return (
        <>
            <Cabecalho pagina="Modelo Izza GPT" />
            <ModeloIzzaGPTComponent />
        </>
    )
}
